import * as Yup from "yup";

const itemTypeValidation = Yup.object().shape({
  item_type: Yup.number().required("Please select a booking type."),
});

export default itemTypeValidation;
